import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import {FileUploadModule} from 'primeng/fileupload';
import { ToastModule} from 'primeng/toast';
import {TableModule } from 'primeng/table';
import {ToggleButtonModule } from 'primeng/togglebutton';
import {DropdownModule } from 'primeng/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';;
import {PaginatorModule} from 'primeng/paginator';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { SharedModule } from '../shared/shared.module';
import {MultiSelectModule} from 'primeng/multiselect';
import {CalendarModule} from 'primeng/calendar';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { SetTargetsRoutingModule } from './set-targets-routing.module';
import { SetTargetsComponent } from './set-targets/set-targets.component';
import { SetTargetsToLeadSourcesComponent } from './set-targets-to-lead-sources/set-targets-to-lead-sources.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptorService } from '../services/token-interceptor.service';


@NgModule({
  declarations: [SetTargetsComponent, SetTargetsToLeadSourcesComponent],
  imports: [
    CommonModule,
    SetTargetsRoutingModule,
    CommonModule,    
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    ModalModule.forRoot(),
    FileUploadModule,
    ToggleButtonModule,
    TableModule,
    ToastModule,
    PaginatorModule,
    AutoCompleteModule,
    SharedModule,
    MultiSelectModule,
    CalendarModule,
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    }
  ],
})
export class SetTargetsModule { }
